import { adminBaseURL } from "../utils/commonUtils";

export const profile_url = (user_id) =>{
    const userProfileBaseUrl = adminBaseURL("user-profiles");

    return `${userProfileBaseUrl}/${user_id}`
}